import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import HeaderSection from '../../components/HeaderSection/HeaderSection';
import BottomSection from '../../components/BottomSection/BottomSection';
import { FaShare, FaHeart, FaBug, FaRedo, FaCopy } from "react-icons/fa";

export default function WhitespaceRemover() {
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const [isFavorite, setIsFavorite] = useState(false);
     useTheme();

  const removeWhitespace = () => {
    if (!inputText) return;
    
    // Remove multiple spaces and trim
    const cleanedText = inputText.replace(/\s+/g, ' ').trim();
    setOutputText(cleanedText);
  };

  const copyToClipboard = () => {
    if (!outputText) return;
    navigator.clipboard.writeText(outputText);
  };

  const resetConverter = () => {
    setInputText("");
    setOutputText("");
  };

  const shareTool = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Multiple Whitespace Remover',
        text: 'Check out this useful whitespace removal tool!',
        url: window.location.href
      }).catch(err => console.log('Error sharing:', err));
    } else {
      // Fallback for browsers that don't support Web Share API
      alert('Web Share API not supported in your browser. Please copy the URL manually.');
    }
  };

  const reportBug = () => {
    window.open('mailto:support@example.com?subject=Bug Report: Whitespace Remover', '_blank');
  };

  React.useEffect(() => {
    removeWhitespace();
  }, [inputText]);

  return (
    <>
      <HeaderSection toolId="whitespaceRemover" />
      <div className="max-w-4xl mx-auto p-4 lg:max-w-full lg:px-4 dark:text-white">
        <div className="bg-white dark:text-white rounded-xl dark:bg-gray-800 shadow-sm dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
            <h1 className="text-2xl font-bold mb-2">
              Multiple Whitespace Remover
            </h1>
            <p className="opacity-90">
              Clean up your text by removing extra spaces and whitespace
            </p>
          </div>

          {/* Main Content */}
          <div className="p-6">
            {/* Action Buttons - Top */}
            <div className="flex flex-wrap gap-3 mb-6">
              <button
                onClick={shareTool}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-md flex items-center gap-2 transition"
              >
                <FaShare /> Share
              </button>
              <button
                onClick={() => setIsFavorite(!isFavorite)}
                className={`px-4 py-2 rounded-md flex items-center gap-2 transition ${isFavorite ? 'bg-red-500 hover:bg-red-600 text-white' : 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
              >
                <FaHeart /> {isFavorite ? 'Remove from Favs' : 'Add to Favs'}
              </button>
              <button
                onClick={reportBug}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-md flex items-center gap-2 transition"
              >
                <FaBug /> Report Bug
              </button>
            </div>

            {/* Input Text Area */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Enter your text...
              </label>
              <textarea
                className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 focus:ring-green-500 focus:border-green-500 h-32"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                placeholder="Type or paste your text here..."
              />
            </div>

            {/* Output Text Area */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Cleaned Text
              </label>
              <textarea
                className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-700 focus:ring-green-500 focus:border-green-500 h-32"
                value={outputText}
                readOnly
                placeholder="Your cleaned text will appear here..."
              />
            </div>

            {/* Action Buttons - Bottom */}
            <div className="flex flex-wrap gap-3">
              <button
                onClick={resetConverter}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-md flex items-center gap-2 transition"
              >
                <FaRedo /> Reset
              </button>
              <button
                onClick={copyToClipboard}
                disabled={!outputText}
                className={`px-4 py-2 rounded-md flex items-center gap-2 transition ${outputText ? 'bg-green-500 hover:bg-green-600 text-white' : 'bg-gray-200 dark:bg-gray-700 cursor-not-allowed'}`}
              >
                <FaCopy /> Copy
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-100 dark:text-white dark:bg-gray-800 p-4 text-center text-sm text-gray-600">
            <p>Remove multiple spaces and clean up your text with one click</p>
          </div>
        </div>
      </div>
      <BottomSection toolId="whitespaceRemover" />
    </>
  );
}